/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import MaterialSymbol from '../../../components/MaterialSymbol';
import { colors } from '@farmlands/mui-theme';
import { DeliveryScheduleProduct } from './DeliverySchedule';

interface ProductCardProps {
  product: DeliveryScheduleProduct;
}

export const OverdrawnIcon = () => (
  <MaterialSymbol variant='fill' sx={{ fontSize: '20px', mb: '2px', color: colors.primary700 }}>
    info
  </MaterialSymbol>
);

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  return (
    <Box
      p={2}
      mb={2}
      sx={{
        backgroundColor: colors.primary100,
        borderRadius: 2,
      }}
    >
      <Stack direction='row' alignItems='center' gap={1}>
        {product.previouslyOverdrawn && <OverdrawnIcon />}
        <Typography variant='body2' color='primary'>
          {product.productDescription}
        </Typography>

        {/* Maybe we do this, maybe not */}
        {/* {product.overdrawn && (
          <Chip
            sx={{
              float: 'right',
              ml: 'auto',
              py: 2,
              px: 1,
              backgroundColor: colors.secondary100,
            }}
            label='Overdrawn'
            color='info'
            icon={<OverdrawnIcon />}
          />
        )} */}
      </Stack>
      <Box display='grid' gridTemplateColumns='repeat(3, 1fr)' gap={2} mt={1}>
        <Box>
          <Typography variant='body2' color='textSecondary'>
            Committed
          </Typography>
          <Typography variant='body1'>{product.quantity.committed}</Typography>
        </Box>
        <Box>
          <Typography variant='body2' color='textSecondary'>
            Released
          </Typography>
          <Typography variant='body1'>
            {product.quantity.released + product.quantity.delivered + product.quantity.invoiced}
          </Typography>
        </Box>
        <Box>
          <Typography variant='body2' color='textSecondary'>
            Remaining
          </Typography>
          <Typography variant='body1'>
            {product.quantity.remaining > 0 ? product.quantity.remaining : 0}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductCard;
